<template>
  <v-dialog
    v-model="visible"
    fullscreen
    transition="dialog-bottom-transition"
    @keydown.esc="close"
  >
    <v-card class="pdf-viewer" @contextmenu.prevent>
      <v-toolbar dark color="#0F3565" dense flat class="pdf-viewer__toolbar">
        <v-toolbar-title class="text-body-2">
          {{ title || $t('Visualizar documento') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <div class="pdf-viewer__container">
        <div v-if="loading" class="pdf-viewer__loading">
          <v-progress-circular indeterminate size="48" width="4" color="primary" />
          <span class="mt-3">{{ $t('Carregando documento...') }}</span>
        </div>

        <iframe
          v-show="!loading"
          ref="pdfFrame"
          :src="viewerSrc"
          class="pdf-viewer__iframe"
          frameborder="0"
          @load="onFrameLoad"
        />

        <div class="pdf-viewer__overlay" @contextmenu.prevent />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PdfViewerDialog',

  props: {
    value: { type: Boolean, default: false },
    url: { type: String, default: '' },
    title: { type: String, default: '' },
  },

  data() {
    return {
      loading: true,
    }
  },

  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },

    viewerSrc() {
      if (!this.url) return ''
      return `${this.url}#toolbar=0&navpanes=0&scrollbar=1`
    },
  },

  watch: {
    value(open) {
      if (open) {
        this.loading = true
        document.addEventListener('keydown', this.blockShortcuts)
      } else {
        document.removeEventListener('keydown', this.blockShortcuts)
      }
    },
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.blockShortcuts)
  },

  methods: {
    close() {
      this.visible = false
    },

    onFrameLoad() {
      this.loading = false
    },

    blockShortcuts(e) {
      if (
        (e.ctrlKey || e.metaKey) &&
        (e.key === 's' || e.key === 'S' || e.key === 'p' || e.key === 'P')
      ) {
        e.preventDefault()
      }
    },
  },
}
</script>

<style scoped>
.pdf-viewer {
  display: flex;
  flex-direction: column;
  height: 100vh;
  user-select: none;
  -webkit-user-select: none;
}

.pdf-viewer__toolbar {
  flex: 0 0 auto !important;
}

.pdf-viewer__container {
  flex: 1;
  position: relative;
  overflow: hidden;
}

.pdf-viewer__iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.pdf-viewer__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.pdf-viewer__loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fafbfc;
  z-index: 2;
  color: #5a6678;
  font-size: 14px;
}
</style>
